import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import {
  NotAPlacementError,
  WorkflowPlacement,
  getWorkflowPlacement,
} from '@/services/workflow/qualification';

export const WORKFLOW_PLACEMENT_QUERY_KEY = 'workflow-placement';

export const useWorkflowPlacement = (
  orgId: string | undefined,
  workflowId: string | undefined,
  options?: Partial<UseQueryOptions<WorkflowPlacement, Error>>,
) =>
  useQuery<WorkflowPlacement, Error>({
    queryKey: [WORKFLOW_PLACEMENT_QUERY_KEY, orgId, workflowId],
    queryFn: async ({ signal }) => {
      if (!orgId || !workflowId) throw new Error('No org or workflow id');
      return getWorkflowPlacement(orgId, workflowId, signal);
    },
    enabled: !!orgId && !!workflowId,
    // Sign-off state moves whenever the other side acts, so a cached
    // verdict would show a stale "waiting on you".
    staleTime: 0,
    refetchOnWindowFocus: false,
    retry: (failureCount, error) =>
      error instanceof NotAPlacementError ? false : failureCount < 2,
    ...options,
  });
